/**
 * New FT experiments are not conducted via `wix-experiments` package and
 * therefore not available in the Editor Yoshi Flow environment.
 * (only in Editor, on the Live Site experiments are conducted on SSR)
 * * https://github.com/wix-private/fed-infra/issues/3597
 *
 * This code conducts an experiment using the Ambassador Feature Toggle service.
 */

import {
  Experiments,
  useEnvironment,
  useExperiments,
} from '@wix/yoshi-flow-editor';

import { useRootProps } from './Widget/contexts';

/**
 * Provide hook to choose, depending on environment, the right experiments instance.
 */
export const useAppExperiments = (): { experiments: Experiments } => {
  const { isEditor } = useEnvironment();
  const { experiments: rootProps } = useRootProps();
  const { experiments: original } = useExperiments();

  return {
    experiments: isEditor
      ? new Experiments({ experiments: rootProps })
      : original,
  };
};
